var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlokkeIkon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9zm5.205-13.45a.502.502 0 0 1 0 .708l-3.268 3.269c.038.154.063.315.063.479a2.005 2.005 0 0 1-2 2.006c-.748 0-1.393-.512-1.736-1.012H7.5c-.275 0-.5-.249-.5-.523v-.954c0-.274.225-.523.5-.523h2.764c.343-.5.988-1.012 1.736-1.012.197 0 .385.049.565.103l3.239-3.237a.5.5 0 0 1 .707 0l.694.696zM12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlokkeIkon);
export default __webpack_public_path__ + "static/media/klokke-ikon.ac16e23d.svg";
export { ForwardRef as ReactComponent };